import { action, computed, makeObservable, observable } from 'mobx';
import { ScrollEvent, notifyNeedToScroll, scrollEmitter } from '@bringg-frontend/monitoring';

import { routesMonitoringRootStore } from './routes-monitoring-root-store';

class RoutesMonitoringViewStore {
	scrollTop: number;
	isCancelModalOpen: boolean;

	constructor(disposeSignal: AbortSignal) {
		makeObservable(this, {
			scrollTop: observable,
			setScrollTop: action,
			isScrolled: computed,
			isCancelModalOpen: observable
		});

		scrollEmitter.on(this.setScrollTop);
		disposeSignal.addEventListener('abort', () => scrollEmitter.off(this.setScrollTop), { once: true });

		this.isCancelModalOpen = false;
	}

	resetScroll() {
		notifyNeedToScroll({
			scrollTop: 0,
			target: undefined,
			immediate: true
		});
	}

	setScrollTop = ({ scrollTop }: ScrollEvent) => {
		this.scrollTop = scrollTop;
	};

	toggleCancelModalOpen = (isOpen: boolean) => {
		this.isCancelModalOpen = isOpen;
	};

	get isScrolled() {
		return this.scrollTop > 0;
	}

	get selectedColor() {
		const {
			routesMonitoringTableViewStore: { getRouteColor },
			selectedTasksStore: { selectedTasks }
		} = routesMonitoringRootStore.getStore();

		if (!selectedTasks.length) {
			return undefined;
		}

		const routeColor = getRouteColor(selectedTasks[0].run_id);

		const secondRouteColor = selectedTasks.find(task => getRouteColor(task.run_id) !== routeColor);

		if (!secondRouteColor) {
			return routeColor;
		}

		return undefined;
	}
}

export default RoutesMonitoringViewStore;
